<div class="container" (click)="onClickInset($event)" [class.right0]="currentState" [class.right400]="!currentState"
    tid="note_history">
    <div class="header">
        <span class="h3-regular header-title">History</span>
        <div class="close-icon">
            <smart-icon name="close" (click)="onClose()" class="light"></smart-icon>
        </div>
    </div>
    <div class="body" loading-spin [isLoading]="reloading" [loadingSize]="'big'">
        <div class="body-item">
            <span class="title-1">Viewers</span>
            <div class="body-content" tid="history_viewer">
                <span *ngFor="let item of viewers; let i = index; trackBy:trackByFn" class="title-user"
                    (click)="viewDetail(item)">{{item.userName
                    + (i !==
                    viewers.length - 1 ? ", " : " ")}}</span>
            </div>
        </div>
        <div class="body-item">
            <span class="title-1">Activities</span>
            <div class="body-content">
                <tam-timeline [data]="activities">
                    <ng-template #content let-dataItem="dataItem">
                        <div class="right-header">
                            <tam-audit-trail-username [data]="dataItem" (viewDetail)="viewDetail($event)">
                            </tam-audit-trail-username>
                            <span class="right-opType">{{dataItem.opType}}</span>
                            <span class="right-text caption-2 right-date">{{dataItem.date}}</span>
                        </div>
                        <div class="right-content">
                            <ng-container *ngIf="dataItem.items && dataItem.items.length > 0">
                                <div *ngFor="let item of dataItem.items" class="right-item">
                                    <span class="body-3 left-text">{{item.title}}</span>
                                    <ng-container *ngIf="item.title === 'Priority'">
                                        <div class="body-2 center-text">
                                            <tam-rating [rating]='item.oldVal' [itemId]=''></tam-rating>
                                        </div>
                                        <div class="body-2 right-text">
                                            <tam-rating [rating]='item.newVal' [itemId]=''></tam-rating>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="item.title !== 'Priority'">
                                        <span class="body-2 center-text"
                                            [ngClass]="{'link-text': item.title === 'Body'}"
                                            (click)="onClickValue(item)">{{item.oldVal}}</span>
                                        <span class="body-2 right-text" [ngClass]="{'link-text': item.title === 'Body'}"
                                            (click)="onClickValue(item)">{{item.newVal}}</span>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </ng-template>
                </tam-timeline>
            </div>
        </div>
    </div>
</div>